export default __webpack_public_path__ + "static/neckband-c760c53dcc6e8f8dd77fd5de9511079b.png";